import React from "react";
import ChatInterface from "./ChatInterface.jsx";

const ResumeView = () => {
  return <ChatInterface />;
};

export default ResumeView;
